<!--
 * @title: 结构性修复
 * @fileName: index
 * @projectName WEB
 * @author ：yaaynn
 * @date ：2020/5/31 17:43
 * @modified By：
 * @version:     1.0$
 * @description: TODO
-->
<template>
    <d2-container>
        <page-body v-show="!dialogShow"
                   :page-size="paging.limit"
                   :total="paging.total"
                   :current-page="paging.page"

                   @size-change="onPagingSizeChange"
                   @current-change="onPagingCurrentLimitChange">
            <template v-slot:default>
                <page-table
                        :buttons="buttons"
                        :table-column-attributes="pageConfig.tableColumnAttributes"
                        :value="tableData"
                        :toolbar-buttons="toolbarButtons"
                        :loading="loading"
                        @search-click="onSearch"
                        @add-click="onAdd"
                        @look-click="onLook"
                        @update-click="onUpdate"
                        @delete-click="onDelete"
                        :handle-column="true"
                >
                    <template v-slot:advanced-search>
                        <popover-form :form-config="searchConfig" v-model="search" @onSubmit="onSearch"></popover-form>
                    </template>
                </page-table>
            </template>
        </page-body>
        <page-edit-layout v-model="dialogValue" v-show="dialogShow">
            <template v-slot:button>
                <div class="common-flex-center-end">
                    <el-button type="primary" v-if="operationType==1||operationType==2" @click="dataSubmit">计算并保存</el-button>
                    <el-button type="primary" @click="dialogShow = false">返回</el-button>
                </div>
            </template>
            <template v-slot>
                <divider title="结构性修复"></divider>
                <dynamic-form ref="dialogValue" :form-config="dialogFormConfig" :disabled="!(operationType==1||operationType==2)" v-model="dialogValue"></dynamic-form>
                <el-dialog :visible.sync="dialogTableVisible" width="80%" custom-class="dialogStyle">
                    <PavementPlanningManagement class="dialog-top" :tableUse="tableUses"></PavementPlanningManagement>
                </el-dialog>
                <divider title="明细信息"></divider>
                <el-table :data="pageConfig.detailsTableData" @row-click="handleRowClick" border height="320">
                    <el-table-column label="养护路段编码" prop="sectionCode">
                    </el-table-column>
                    <el-table-column label="行车方向" prop="drivingDirection">
                    </el-table-column>
                    <el-table-column label="面层类型" prop="surfaceType">
                    </el-table-column>
                    <el-table-column label="车道位置" prop="lane">
                    </el-table-column>
                    <el-table-column label="起点位置" sortable prop="startStake">
                      <template slot-scope="scope">{{ scope.row.startStake | stakeTableFilter }}</template>
                    </el-table-column>
                    <el-table-column label="止点位置" sortable prop="endStake">
                      <template slot-scope="scope">{{ scope.row.endStake | stakeTableFilter }}</template>
                    </el-table-column>
                    <el-table-column label="结构性方案" prop="overhaulPlan">
                    </el-table-column>
                    <el-table-column label="结构性修复路段费用(万元)" prop="maintenanceCosts">
                    </el-table-column>
                </el-table>
            </template>
        </page-edit-layout>
    </d2-container>
</template>

<script>
    import PageBody from "@/components/Pages/PageBody";
    import PageTable from "@/components/Pages/PageTable/index";
    import PageEditLayout from "@/components/Pages/layout/PageEditLayout";
    import PavementPlanningManagement from "@/views/decision/PavementPlanningManagement/index"

    export default {
        name: "index",
        components: {PageTable, PageBody, PageEditLayout, PavementPlanningManagement},
        data() {
            return {
                initializeForm:{},
                dialogTableVisible: false,
                tableUses: {
                    //数据弹框
                    show: true,
                    size: "mini",
                    type: "success",
                    plain: true,
                    round: false,
                    circle: false,
                    loading: false,
                    disabled: false,
                    icon: "",
                    types: 1,
                    title: "使用",
                    name: "使用",
                    click: this.useRoute
                },
                //分页
                paging: {},
                //搜索数据
                search: {
                    routeCode:"",
                },
                //表格数据
                tableData: [],
                //页面配置
                pageConfig: {
                    // 表格列属性
                    tableColumnAttributes: [
                        {label: '路面规划管理名称', prop: 'partitionName', type: 'String', width: 'auto', children: []},
                        {label: '规划路线编码', prop: 'routeCode', type: 'String', width: 'auto', children: []},
                        {label: '规划路线名称', prop: 'routeName', type: 'String', width: 'auto', children: []},
                        {label: '规划年度', prop: 'annual', type: 'String', width: 'auto', children: []},
                        {label: '结构性修复路段里程(km)', prop: 'roadMileage', type: 'String', width: 'auto', children: []},
                        {label: '结构性修复路段费用(万元)', prop: 'maintenanceCosts', type: 'String', width: 'auto', children: []},
                    ],
                    // 明细表
                    detailsTableColumnAttributes: [
                        {label: '养护路段编码', prop: 'sectionCode', type: 'String', width: 'auto', children: []},
                        {label: '行车方向', prop: 'drivingDirection', type: 'String', width: 'auto', children: []},
                        {label: '面层类型', prop: 'surfaceType', type: 'String', width: 'auto', children: []},
                        {label: '车道位置', prop: 'lane', type: 'String', width: 'auto', children: []},
                        {label: '起点桩号', prop: 'startStake', type: 'Stake', width: 'auto', children: []},
                        {label: '止点桩号', prop: 'endStake', type: 'Stake', width: 'auto', children: []},
                        {label: '结构性方案', prop: 'overhaulPlan', type: 'String', width: 'auto', children: []},
                        {label: '结构性修复路段费用(万元)', prop: 'maintenanceCosts', type: 'Number', width: 'auto', children: []},
                    ],
                    detailsTableData: [],
                    // 大修工艺
                    processTableColumnAttributes: [
                        {label: '工艺', prop: 'craft', type: 'String', width: 'auto', children: []},
                        {label: '结构层', prop: 'structureLayer', type: 'String', width: 'auto', children: []},
                        {label: '材料名称', prop: 'materialsName', type: 'String', width: 'auto', children: []},
                        {label: '厚度(cm)', prop: 'thicknessNum', type: 'Number', width: 'auto', children: []},
                    ],
                    processTableData: [],
                },
                // 工具栏按钮
                toolbarButtons: this.ButtonEnums.BarButton.addButton,
                // 表格加载
                loading: false,
                // 查看模式
                lookModel: false,
                //操作类型
                operationType: 1,
                // 弹出层数据
                dialogValue: {
                    rowCode :0,/// 主键    int
                    partitionId :0,/// 路面规划管理id  int
                    partitionName :'',/// 路面规划管理名称
                    routeId :0,/// 路线id
                    routeCode :'',/// 路线编码
                    routeName :'',/// 路线名称
                    annual :0,/// 分析年度    int
                    roadMileage :0,/// 大修路段里程(km)    decimal
                    maintenanceCosts :0,/// 大修路段费用(万元)  decimal
                    remark :'',
                    createUser :'',
                    createUserName :'',
                    createTime :'',
                    updateUser :'',
                    updateUserName :'',
                    updateTime :'',
                    status :'',
                    r1 :'',
                    r2 :'',
                    r3 :'',
                    r4 :'',
                    r5 :'',
                    sublist :[],/// 大修养护子表    List
                },
                dialogChildValue:{
                    value1:{
                        rowCode :0,/// 主键    int
                        pCode :0,/// 主表id  int
                        routeId :'',/// 路线id
                        routeCode :'',/// 路线编码
                        routeName :'',/// 路线名称
                        sectionCode :'',/// 养护路段编码
                        sectionId :0,/// 养护路段id
                        upperLayerMaterial :'',/// 上面层材料
                        upperLayer :0,/// 上面层厚度  decimal
                        middleLayerMaterial :'',/// 中面层材料
                        middleLayer :0,/// 中面层厚度  decimal
                        followingLayerMaterial :'',/// 下面层材料
                        followingLayer :0,/// 下面层厚度  decimal
                        drivingDirection :'',/// 行车方向
                        lane :'',/// 车道位置
                        surfaceType :'',/// 面层类型
                        startStake :0,/// 起点桩号    decimal
                        endStake :0,/// 止点桩号    decimal
                        overhaulPlan :'',/// 大修方案
                        maintenanceCosts :0,/// 大修路段费用(万元)  decimal
                        remark :'',
                        createUser :'',
                        createUserName :'',
                        createTime :'',
                        updateUser :'',
                        updateUserName :'',
                        updateTime :'',
                        status :'',
                        r1 :'',
                        r2 :'',
                        r3 :'',
                        r4 :'',
                        r5 :'',
                        sublists :[],/// 养护具体措施    List
                    },
                    value2:{
                        rowCode :0,/// 主键    int
                        pCode :'',/// 主表ID
                        craft :'',/// 工艺
                        csortCode :0,/// 工艺排序    int
                        structureLayer :'',/// 结构层
                        ssortCode :0,/// 结构层排序  int
                        materialsName :'',/// 材料名称
                        thicknessNum :0,/// 厚度（cm）  int
                        unitPrice:"",//单价
                        remark :'',
                        createUser :'',
                        createUserName :'',
                        createTime :'',
                        updateUser :'',
                        updateUserName :'',
                        updateTime :'',
                        status :'',
                        r1 :'',
                        r2 :'',
                        r3 :'',
                        r4 :'',
                        r5 :'',
                    },
                },
                //搜索框配置
                searchConfig: {
                    "list": [{
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "请输入路线编码",
                            "disabled": false,
                            "remoteFunc": "func_1590921615000_8607"
                        },
                        "name": "路线编码",
                        "key": "routeCode",
                        "model": "routeCode",
                        "rules": [{"type": "string", "message": "路线编码格式不正确"}]
                    }], "config": {"labelWidth": 100, "labelPosition": "right", "size": "small", "customClass": ""}
                },
                // 弹出层表单配置
                dialogFormConfig: {
                    "list": [{
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": true,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "请选择路面规划管理",
                            "disabled": false,
                            "remoteFunc": "func_1590919288000_36490",
                            onFocus: this.routeFileForm
                        },
                        "name": "路面规划管理名称",
                        "key": "partitionName",
                        "model": "partitionName",
                        "rules": [{"type": "string", "message": "路面规划管理格式不正确"}, {
                            "required": true,
                            "message": "路面规划管理必须填写"
                        }]
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1590919288000_36490"
                        },
                        "name": "规划路线编码",
                        "key": "routeCode",
                        "model": "routeCode",
                        "rules": [{"type": "string", "message": "规划路线编码格式不正确"}]
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1590919288000_36490"
                        },
                        "name": "规划路线名称",
                        "key": "routeName",
                        "model": "routeName",
                        "rules": [{"type": "string", "message": "规划路线名称格式不正确"}]
                    }, {
                        type: "number",
                        icon: "icon-number",
                        options: {
                          width: "",required: false,defaultValue: 0,min: 0,max: 999999999,step: 1,disabled: true,controlsPosition: "",customClass: "",labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,remoteFunc: "func_1573045175616"
                        },
                        name: "规划年度",
                        novalid: {},
                        key: "annual",
                        model: "annual",
                        rules: [{required: false,message: "必须填写"}]
                    }, {
                        type: "number",
                        icon: "icon-number",
                        options: {
                          width: "",required: false,defaultValue: 0,min: 0,max: 999999999,step: 0.001,disabled: true,controlsPosition: "",customClass: "",labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,remoteFunc: "func_1573045175616"
                        },
                        name: "结构性修复路段里程(km)",
                        novalid: {},
                        key: "roadMileage",
                        model: "roadMileage",
                        rules: [{required: false,message: "必须填写"}]
                    }, {
                        type: "number",
                        icon: "icon-number",
                        options: {
                          width: "",required: false,defaultValue: 0,min: 0,max: 999999999,step: 0.0001,disabled: true,controlsPosition: "",customClass: "",labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,remoteFunc: "func_1573045175616"
                        },
                        name: "结构性修复路段维修费用(万元)",
                        novalid: {},
                        key: "maintenanceCosts",
                        model: "maintenanceCosts",
                        rules: [{required: false,message: "必须填写"}]
                    }, {
                        "type": "textarea",
                        "icon": "icon-diy-com-textarea",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "disabled": false,
                            "pattern": "",
                            "placeholder": "",
                            "remoteFunc": "func_1590919429000_76721"
                        },
                        "name": "备注",
                        "key": "1590919429000_76721",
                        "model": "t9",
                        "rules": []
                    }], "config": {"labelWidth": 100, "labelPosition": "right", "size": "small"}
                },
                // 弹出层控制属性
                dialogShow: false
            }
        },
        methods: {
            //分页大小变更事件
            onPagingSizeChange(size) {
                this.paging.setSize(size)
                this.refreshData(this.paging, this.search)
            },
            // 分页当前页变动事件
            onPagingCurrentLimitChange(current) {
                this.paging.setIndex(current)
                this.refreshData(this.paging, this.search)
            },
            // 搜索事件
            onSearch() {
                this.refreshData(this.paging, this.search);
            },
            // 新增
            onAdd() {
                this.dialogShow = true
                this.operationType = 1;
                this.dialogValue = this.$formSetForm(this.initializeForm , this.initializeForm)
                this.pageConfig.detailsTableData=[];
                this.pageConfig.processTableData=[];
            },
            // 查看
            onLook(row) {
                this.$http.post(this.$url.routeDecision.getoverhaulmaintenances,{rowCode:row.rowCode}).then(res=>{
                    this.operationType = 3;
                    this.dialogShow = true;
                    this.dialogValue=res.data[0];
                    if(res.data[0].sublist){
                        this.pageConfig.detailsTableData=res.data[0].sublist;
                    }else{
                        this.pageConfig.detailsTableData=[];
                    }
                    this.pageConfig.processTableData=[];
                })
            },
            // 修改
            onUpdate(row) {
                this.$http.post(this.$url.routeDecision.getoverhaulmaintenances,{rowCode:row.rowCode}).then(res=>{
                    this.operationType = 3;
                    this.dialogShow = true;
                    this.dialogValue=res.data[0];
                    if(res.data[0].sublist){
                        this.pageConfig.detailsTableData=res.data[0].sublist;
                    }else{
                        this.pageConfig.detailsTableData=[];
                    }
                    this.pageConfig.processTableData=[];
                })
            },
            // 删除
            onDelete(row) {
                let forms = this.$formSetForm(this.dialogValue, row);
                this.$msgDel(this.$url.routeDecision.operationoverhaulmaintenance, {
                    overhaulMaintenance: forms,
                    operationType: 8
                }).then(res => {
                    this.refreshData(this.paging, this.search);
                });
            },
            initial() {
                this.refreshData(this.paging)
            },
            // 刷新数据
            refreshData(paging, search, callback) {
                const searchData = this.Tools.get().ObjectTools.merge(paging, search),
                    url = this.$url.routeDecision.getoverhaulmaintenances
                // 由于web storm模板影响 请自行配置以下代码
                this.loading = true
                this.$http.post(url, searchData).then(res=>{
                    this.tableData=res.data;
                    this.paging.total = res.pageCount;
                    this.loading = false
                }).catch(error=>{
                    this.loading = false
                })
            },
            //明细列表点击事件
            handleRowClick(row){
                if(row.sublists){
                    this.pageConfig.processTableData = row.sublists;
                }else{
                    this.pageConfig.processTableData = row.sublists;
                }
            },
            //规划管理使用
            routeFileForm() {
                this.dialogTableVisible = true;
            },
            useRoute(row, index) {
                this.dialogTableVisible = false
                this.dialogValue.partitionId = row.rowCode
                this.dialogValue.partitionName = row.planName
                this.dialogValue.routeId = row.routeId
                this.dialogValue.routeName = row.routeName
                this.dialogValue.routeCode = row.routeCode
                this.dialogValue.annual = row.aannual
            },
            dataSubmit(){
                this.$refs.dialogValue.submit().then(res => {
                    var forms = this.$formSetForm(this.dialogValue, this.dialogValue);
                    this.$http
                        .postHandle("保存", this.$url.routeDecision.operationoverhaulmaintenance, {
                          overhaulMaintenance: forms,
                        })
                        .then(res => {
                            this.operationType = 3;
                            // this.dialogShow = false;
                            this.dataForm=res.data;
                            this.pageConfig.detailsTableData=res.data.sublist;
                            this.refreshData(this.paging, this.search);
                        })
                        .catch(error => {
                          console.log(error);
                        });
                });
            },
        },
        computed: {
            // 表格按钮
            buttons() {
                return  this.ButtonEnums.TableButtons.descriptionButton 
            },
        },
        mounted() {
            this.paging = this.Paging.default()
            this.initializeForm = this.$formSetForm(this.dialogValue , this.dialogValue)
            this.initial()
        }
    }
</script>

<style scoped lang="scss">
    .breaking-rate-eacharts-container {
        display: flex;

        .button-container {
            min-width: 80px;
            display: flex;
            flex-direction: column;

            .button-header {
                display: flex;
                justify-items: center;
                align-items: center;
                height: 20%;
                box-sizing: border-box;
                border-bottom: 2px solid #F6F6F6;
            }

            .button-footer {
                display: flex;
                align-items: center;
                height: 80%;
            }
        }

        .echarts-container {
            flex: 1;
        }
    }
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/decision/PavementMaintenancePlanningCustomization/RepairAndMaintenance/OverhaulMaintenance/index.vue"
}
</vue-filename-injector>
